export enum ScreenSize {
  XS,
  S,
  M,
  L,
  XL,
}
